import React, { useEffect } from 'react';
import { Form, Modal } from 'antd';
import dayjs, { type Dayjs } from 'dayjs';
import type { CompleteRecurringPayload } from '../api/tasks';
import RecurringDueDateFields from './RecurringDueDateFields';

export interface CompleteRecurringFormValues {
  nextDueDate: Dayjs;
}

interface CompleteRecurringModalProps {
  open: boolean;
  taskId: string | null;
  loading?: boolean;
  onCancel: () => void;
  onSubmit: (taskId: string, payload: CompleteRecurringPayload) => void;
}

const CompleteRecurringModal: React.FC<CompleteRecurringModalProps> = ({
  open,
  taskId,
  loading,
  onCancel,
  onSubmit,
}) => {
  const [form] = Form.useForm<CompleteRecurringFormValues>();

  useEffect(() => {
    if (open) {
      form.setFieldsValue({
        nextDueDate: dayjs().add(30, 'day').startOf('day'),
      });
    } else {
      form.resetFields();
    }
  }, [open, form]);

  const handleOk = () => {
    if (!taskId) return;
    form.validateFields().then((values) => {
      onSubmit(taskId, {
        nextDueDate: values.nextDueDate.format('YYYY-MM-DD'),
      });
    });
  };

  return (
    <Modal
      title="Complete recurring task"
      open={open}
      onOk={handleOk}
      onCancel={onCancel}
      confirmLoading={loading}
      okText="Complete and schedule next"
      destroyOnClose
      width={480}
    >
      <div className="cp-form-section">
        <Form form={form} layout="vertical">
          <RecurringDueDateFields />
        </Form>
      </div>
    </Modal>
  );
};

export default CompleteRecurringModal;
